import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//shows invoice notes and event comment
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <div className="col">
            <table border = "2" cellPadding="15" cellSpacing="10" className="notes_table">
                <tbody>
                <tr ><td className="table_text">CONFIRMED
                    FOR
                    ________________</td></tr>
                {IV1_PageDetails.InvoiceNotes.map((note, key) => {
                    return (
                        <tr key={key+"note"}><td key={key+"invoice_note"}
                                                 className="table_text">{key+1}) {note}</td></tr>
                    )
                })}
                <tr>
                    <td className="table_text">
                        {IV1_PageDetails.EventComment ?  IV1_PageDetails.EventComment : "" }
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    )
}